/* eslint-disable */

export const protobufPackage = "modal.client";

export enum AppDeployVisibility {
  APP_DEPLOY_VISIBILITY_UNSPECIFIED = "APP_DEPLOY_VISIBILITY_UNSPECIFIED",
  APP_DEPLOY_VISIBILITY_WORKSPACE = "APP_DEPLOY_VISIBILITY_WORKSPACE",
  APP_DEPLOY_VISIBILITY_PUBLIC = "APP_DEPLOY_VISIBILITY_PUBLIC",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AppDisconnectReason {
  APP_DISCONNECT_REASON_UNSPECIFIED = "APP_DISCONNECT_REASON_UNSPECIFIED",
  APP_DISCONNECT_REASON_LOCAL_EXCEPTION = "APP_DISCONNECT_REASON_LOCAL_EXCEPTION",
  APP_DISCONNECT_REASON_KEYBOARD_INTERRUPT = "APP_DISCONNECT_REASON_KEYBOARD_INTERRUPT",
  APP_DISCONNECT_REASON_ENTRYPOINT_COMPLETED = "APP_DISCONNECT_REASON_ENTRYPOINT_COMPLETED",
  APP_DISCONNECT_REASON_DEPLOYMENT_EXCEPTION = "APP_DISCONNECT_REASON_DEPLOYMENT_EXCEPTION",
  APP_DISCONNECT_REASON_REMOTE_EXCEPTION = "APP_DISCONNECT_REASON_REMOTE_EXCEPTION",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/**
 * NOTE: make sure to update the frontend if we add a new state here
 * https://github.com/modal-labs/modal/blob/main/frontend/src/routes/(dashboard)/%5B%5Bworkspace%5D%5D/apps/+page.svelte#L95
 */
export enum AppState {
  APP_STATE_UNSPECIFIED = "APP_STATE_UNSPECIFIED",
  /** APP_STATE_EPHEMERAL - Will be discharged when the client disconnects */
  APP_STATE_EPHEMERAL = "APP_STATE_EPHEMERAL",
  APP_STATE_DETACHED = "APP_STATE_DETACHED",
  /** APP_STATE_DEPLOYED - Will be discharged when overwritten */
  APP_STATE_DEPLOYED = "APP_STATE_DEPLOYED",
  /** APP_STATE_STOPPING - Winding down app due to user termination. */
  APP_STATE_STOPPING = "APP_STATE_STOPPING",
  /** APP_STATE_STOPPED - Stopped */
  APP_STATE_STOPPED = "APP_STATE_STOPPED",
  /** APP_STATE_INITIALIZING - App is created and in process of deployment. */
  APP_STATE_INITIALIZING = "APP_STATE_INITIALIZING",
  /** APP_STATE_DISABLED - Same as stopped but prevented from being garbage collected */
  APP_STATE_DISABLED = "APP_STATE_DISABLED",
  /** APP_STATE_DETACHED_DISCONNECTED - App is detached and local client has disconnected. */
  APP_STATE_DETACHED_DISCONNECTED = "APP_STATE_DETACHED_DISCONNECTED",
  /**
   * APP_STATE_DERIVED - App is derived from another workspace. Acts as a static, immutable group of functions.
   *
   * @deprecated
   */
  APP_STATE_DERIVED = "APP_STATE_DERIVED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AppStopSource {
  APP_STOP_SOURCE_UNSPECIFIED = "APP_STOP_SOURCE_UNSPECIFIED",
  APP_STOP_SOURCE_CLI = "APP_STOP_SOURCE_CLI",
  APP_STOP_SOURCE_PYTHON_CLIENT = "APP_STOP_SOURCE_PYTHON_CLIENT",
  APP_STOP_SOURCE_WEB = "APP_STOP_SOURCE_WEB",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum CertificateStatus {
  CERTIFICATE_STATUS_PENDING = "CERTIFICATE_STATUS_PENDING",
  CERTIFICATE_STATUS_ISSUED = "CERTIFICATE_STATUS_ISSUED",
  CERTIFICATE_STATUS_FAILED = "CERTIFICATE_STATUS_FAILED",
  CERTIFICATE_STATUS_REVOKED = "CERTIFICATE_STATUS_REVOKED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum CheckpointStatus {
  CHECKPOINT_STATUS_UNSPECIFIED = "CHECKPOINT_STATUS_UNSPECIFIED",
  CHECKPOINT_STATUS_PENDING = "CHECKPOINT_STATUS_PENDING",
  CHECKPOINT_STATUS_PROCESSING = "CHECKPOINT_STATUS_PROCESSING",
  CHECKPOINT_STATUS_READY = "CHECKPOINT_STATUS_READY",
  CHECKPOINT_STATUS_FAILED = "CHECKPOINT_STATUS_FAILED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum ClientType {
  CLIENT_TYPE_UNSPECIFIED = "CLIENT_TYPE_UNSPECIFIED",
  /** CLIENT_TYPE_CLIENT - modal-client: Modal Python SDK */
  CLIENT_TYPE_CLIENT = "CLIENT_TYPE_CLIENT",
  /** CLIENT_TYPE_WORKER - modal-worker */
  CLIENT_TYPE_WORKER = "CLIENT_TYPE_WORKER",
  /** CLIENT_TYPE_CONTAINER - modal-client from inside containers */
  CLIENT_TYPE_CONTAINER = "CLIENT_TYPE_CONTAINER",
  /** CLIENT_TYPE_WEB_SERVER - modal-web */
  CLIENT_TYPE_WEB_SERVER = "CLIENT_TYPE_WEB_SERVER",
  /** CLIENT_TYPE_NOTEBOOK_KERNEL - kernelshim.py from notebooks */
  CLIENT_TYPE_NOTEBOOK_KERNEL = "CLIENT_TYPE_NOTEBOOK_KERNEL",
  /** CLIENT_TYPE_LIBMODAL - libmodal: experimental client library */
  CLIENT_TYPE_LIBMODAL = "CLIENT_TYPE_LIBMODAL",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum CloudProvider {
  CLOUD_PROVIDER_UNSPECIFIED = "CLOUD_PROVIDER_UNSPECIFIED",
  CLOUD_PROVIDER_AWS = "CLOUD_PROVIDER_AWS",
  CLOUD_PROVIDER_GCP = "CLOUD_PROVIDER_GCP",
  CLOUD_PROVIDER_AUTO = "CLOUD_PROVIDER_AUTO",
  CLOUD_PROVIDER_OCI = "CLOUD_PROVIDER_OCI",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum DNSRecordType {
  DNS_RECORD_TYPE_A = "DNS_RECORD_TYPE_A",
  DNS_RECORD_TYPE_TXT = "DNS_RECORD_TYPE_TXT",
  DNS_RECORD_TYPE_CNAME = "DNS_RECORD_TYPE_CNAME",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/** Which data format a binary message is encoded with. */
export enum DataFormat {
  DATA_FORMAT_UNSPECIFIED = "DATA_FORMAT_UNSPECIFIED",
  /** DATA_FORMAT_PICKLE - Cloudpickle */
  DATA_FORMAT_PICKLE = "DATA_FORMAT_PICKLE",
  /** DATA_FORMAT_ASGI - "Asgi" protobuf message */
  DATA_FORMAT_ASGI = "DATA_FORMAT_ASGI",
  /** DATA_FORMAT_GENERATOR_DONE - "GeneratorDone" protobuf message */
  DATA_FORMAT_GENERATOR_DONE = "DATA_FORMAT_GENERATOR_DONE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum DeploymentNamespace {
  DEPLOYMENT_NAMESPACE_UNSPECIFIED = "DEPLOYMENT_NAMESPACE_UNSPECIFIED",
  DEPLOYMENT_NAMESPACE_WORKSPACE = "DEPLOYMENT_NAMESPACE_WORKSPACE",
  DEPLOYMENT_NAMESPACE_GLOBAL = "DEPLOYMENT_NAMESPACE_GLOBAL",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum ExecOutputOption {
  EXEC_OUTPUT_OPTION_UNSPECIFIED = "EXEC_OUTPUT_OPTION_UNSPECIFIED",
  EXEC_OUTPUT_OPTION_DEVNULL = "EXEC_OUTPUT_OPTION_DEVNULL",
  EXEC_OUTPUT_OPTION_PIPE = "EXEC_OUTPUT_OPTION_PIPE",
  EXEC_OUTPUT_OPTION_STDOUT = "EXEC_OUTPUT_OPTION_STDOUT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum FileDescriptor {
  FILE_DESCRIPTOR_UNSPECIFIED = "FILE_DESCRIPTOR_UNSPECIFIED",
  FILE_DESCRIPTOR_STDOUT = "FILE_DESCRIPTOR_STDOUT",
  FILE_DESCRIPTOR_STDERR = "FILE_DESCRIPTOR_STDERR",
  FILE_DESCRIPTOR_INFO = "FILE_DESCRIPTOR_INFO",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum FunctionCallInvocationType {
  FUNCTION_CALL_INVOCATION_TYPE_UNSPECIFIED = "FUNCTION_CALL_INVOCATION_TYPE_UNSPECIFIED",
  FUNCTION_CALL_INVOCATION_TYPE_SYNC_LEGACY = "FUNCTION_CALL_INVOCATION_TYPE_SYNC_LEGACY",
  FUNCTION_CALL_INVOCATION_TYPE_ASYNC_LEGACY = "FUNCTION_CALL_INVOCATION_TYPE_ASYNC_LEGACY",
  FUNCTION_CALL_INVOCATION_TYPE_ASYNC = "FUNCTION_CALL_INVOCATION_TYPE_ASYNC",
  FUNCTION_CALL_INVOCATION_TYPE_SYNC = "FUNCTION_CALL_INVOCATION_TYPE_SYNC",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum FunctionCallType {
  FUNCTION_CALL_TYPE_UNSPECIFIED = "FUNCTION_CALL_TYPE_UNSPECIFIED",
  FUNCTION_CALL_TYPE_UNARY = "FUNCTION_CALL_TYPE_UNARY",
  FUNCTION_CALL_TYPE_MAP = "FUNCTION_CALL_TYPE_MAP",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum GPUType {
  /**
   * GPU_TYPE_UNSPECIFIED - Note: this enum is no longer used by current clients - don't add new types
   * Old clients still send it, so we use it server-side for compatibility
   */
  GPU_TYPE_UNSPECIFIED = "GPU_TYPE_UNSPECIFIED",
  GPU_TYPE_T4 = "GPU_TYPE_T4",
  GPU_TYPE_A100 = "GPU_TYPE_A100",
  GPU_TYPE_A10G = "GPU_TYPE_A10G",
  GPU_TYPE_ANY = "GPU_TYPE_ANY",
  GPU_TYPE_A100_80GB = "GPU_TYPE_A100_80GB",
  GPU_TYPE_L4 = "GPU_TYPE_L4",
  GPU_TYPE_H100 = "GPU_TYPE_H100",
  GPU_TYPE_L40S = "GPU_TYPE_L40S",
  GPU_TYPE_H200 = "GPU_TYPE_H200",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum ObjectCreationType {
  /** OBJECT_CREATION_TYPE_UNSPECIFIED - just lookup */
  OBJECT_CREATION_TYPE_UNSPECIFIED = "OBJECT_CREATION_TYPE_UNSPECIFIED",
  OBJECT_CREATION_TYPE_CREATE_IF_MISSING = "OBJECT_CREATION_TYPE_CREATE_IF_MISSING",
  OBJECT_CREATION_TYPE_CREATE_FAIL_IF_EXISTS = "OBJECT_CREATION_TYPE_CREATE_FAIL_IF_EXISTS",
  OBJECT_CREATION_TYPE_CREATE_OVERWRITE_IF_EXISTS = "OBJECT_CREATION_TYPE_CREATE_OVERWRITE_IF_EXISTS",
  /** OBJECT_CREATION_TYPE_ANONYMOUS_OWNED_BY_APP - deprecate at some point */
  OBJECT_CREATION_TYPE_ANONYMOUS_OWNED_BY_APP = "OBJECT_CREATION_TYPE_ANONYMOUS_OWNED_BY_APP",
  OBJECT_CREATION_TYPE_EPHEMERAL = "OBJECT_CREATION_TYPE_EPHEMERAL",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum ParameterType {
  PARAM_TYPE_UNSPECIFIED = "PARAM_TYPE_UNSPECIFIED",
  PARAM_TYPE_STRING = "PARAM_TYPE_STRING",
  PARAM_TYPE_INT = "PARAM_TYPE_INT",
  /** PARAM_TYPE_PICKLE - currently unused */
  PARAM_TYPE_PICKLE = "PARAM_TYPE_PICKLE",
  PARAM_TYPE_BYTES = "PARAM_TYPE_BYTES",
  /** PARAM_TYPE_UNKNOWN - used in schemas to signify unrecognized or un-annotated types */
  PARAM_TYPE_UNKNOWN = "PARAM_TYPE_UNKNOWN",
  PARAM_TYPE_LIST = "PARAM_TYPE_LIST",
  PARAM_TYPE_DICT = "PARAM_TYPE_DICT",
  PARAM_TYPE_NONE = "PARAM_TYPE_NONE",
  PARAM_TYPE_BOOL = "PARAM_TYPE_BOOL",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum ProgressType {
  /** IMAGE_SNAPSHOT_UPLOAD - TODO(erikbern): shouldn't be zero, and needs prefix */
  IMAGE_SNAPSHOT_UPLOAD = "IMAGE_SNAPSHOT_UPLOAD",
  /** FUNCTION_QUEUED - TODO(erikbern): needs_prefix */
  FUNCTION_QUEUED = "FUNCTION_QUEUED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum ProxyIpStatus {
  PROXY_IP_STATUS_UNSPECIFIED = "PROXY_IP_STATUS_UNSPECIFIED",
  PROXY_IP_STATUS_CREATING = "PROXY_IP_STATUS_CREATING",
  PROXY_IP_STATUS_ONLINE = "PROXY_IP_STATUS_ONLINE",
  PROXY_IP_STATUS_TERMINATED = "PROXY_IP_STATUS_TERMINATED",
  PROXY_IP_STATUS_UNHEALTHY = "PROXY_IP_STATUS_UNHEALTHY",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum ProxyType {
  PROXY_TYPE_UNSPECIFIED = "PROXY_TYPE_UNSPECIFIED",
  PROXY_TYPE_LEGACY = "PROXY_TYPE_LEGACY",
  PROXY_TYPE_VPROX = "PROXY_TYPE_VPROX",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum RateLimitInterval {
  RATE_LIMIT_INTERVAL_UNSPECIFIED = "RATE_LIMIT_INTERVAL_UNSPECIFIED",
  RATE_LIMIT_INTERVAL_SECOND = "RATE_LIMIT_INTERVAL_SECOND",
  RATE_LIMIT_INTERVAL_MINUTE = "RATE_LIMIT_INTERVAL_MINUTE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum RegistryAuthType {
  /** REGISTRY_AUTH_TYPE_UNSPECIFIED - Older clients send this instead of "public". */
  REGISTRY_AUTH_TYPE_UNSPECIFIED = "REGISTRY_AUTH_TYPE_UNSPECIFIED",
  REGISTRY_AUTH_TYPE_AWS = "REGISTRY_AUTH_TYPE_AWS",
  REGISTRY_AUTH_TYPE_GCP = "REGISTRY_AUTH_TYPE_GCP",
  REGISTRY_AUTH_TYPE_PUBLIC = "REGISTRY_AUTH_TYPE_PUBLIC",
  REGISTRY_AUTH_TYPE_STATIC_CREDS = "REGISTRY_AUTH_TYPE_STATIC_CREDS",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum SeekWhence {
  SEEK_SET = "SEEK_SET",
  SEEK_CUR = "SEEK_CUR",
  SEEK_END = "SEEK_END",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum SystemErrorCode {
  SYSTEM_ERROR_CODE_UNSPECIFIED = "SYSTEM_ERROR_CODE_UNSPECIFIED",
  /** SYSTEM_ERROR_CODE_PERM - EPERM: Operation not permitted */
  SYSTEM_ERROR_CODE_PERM = "SYSTEM_ERROR_CODE_PERM",
  /** SYSTEM_ERROR_CODE_NOENT - ENOENT: No such file or directory */
  SYSTEM_ERROR_CODE_NOENT = "SYSTEM_ERROR_CODE_NOENT",
  /** SYSTEM_ERROR_CODE_IO - EIO: Input/output error */
  SYSTEM_ERROR_CODE_IO = "SYSTEM_ERROR_CODE_IO",
  /** SYSTEM_ERROR_CODE_NXIO - ENXIO: No such device or address */
  SYSTEM_ERROR_CODE_NXIO = "SYSTEM_ERROR_CODE_NXIO",
  /** SYSTEM_ERROR_CODE_NOMEM - ENOMEM: Out of memory */
  SYSTEM_ERROR_CODE_NOMEM = "SYSTEM_ERROR_CODE_NOMEM",
  /** SYSTEM_ERROR_CODE_ACCES - EACCES: Permission denied */
  SYSTEM_ERROR_CODE_ACCES = "SYSTEM_ERROR_CODE_ACCES",
  /** SYSTEM_ERROR_CODE_EXIST - EEXIST: File exists */
  SYSTEM_ERROR_CODE_EXIST = "SYSTEM_ERROR_CODE_EXIST",
  /** SYSTEM_ERROR_CODE_NOTDIR - ENOTDIR: Not a directory */
  SYSTEM_ERROR_CODE_NOTDIR = "SYSTEM_ERROR_CODE_NOTDIR",
  /** SYSTEM_ERROR_CODE_ISDIR - EISDIR: Is a directory */
  SYSTEM_ERROR_CODE_ISDIR = "SYSTEM_ERROR_CODE_ISDIR",
  /** SYSTEM_ERROR_CODE_INVAL - EINVAL: Invalid argument */
  SYSTEM_ERROR_CODE_INVAL = "SYSTEM_ERROR_CODE_INVAL",
  /** SYSTEM_ERROR_CODE_MFILE - EMFILE: Too many open files */
  SYSTEM_ERROR_CODE_MFILE = "SYSTEM_ERROR_CODE_MFILE",
  /** SYSTEM_ERROR_CODE_FBIG - EFBIG: File too large */
  SYSTEM_ERROR_CODE_FBIG = "SYSTEM_ERROR_CODE_FBIG",
  /** SYSTEM_ERROR_CODE_NOSPC - ENOSPC: No space left on device */
  SYSTEM_ERROR_CODE_NOSPC = "SYSTEM_ERROR_CODE_NOSPC",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum TaskState {
  TASK_STATE_UNSPECIFIED = "TASK_STATE_UNSPECIFIED",
  TASK_STATE_CREATED = "TASK_STATE_CREATED",
  TASK_STATE_QUEUED = "TASK_STATE_QUEUED",
  TASK_STATE_WORKER_ASSIGNED = "TASK_STATE_WORKER_ASSIGNED",
  TASK_STATE_LOADING_IMAGE = "TASK_STATE_LOADING_IMAGE",
  TASK_STATE_ACTIVE = "TASK_STATE_ACTIVE",
  TASK_STATE_COMPLETED = "TASK_STATE_COMPLETED",
  TASK_STATE_CREATING_CONTAINER = "TASK_STATE_CREATING_CONTAINER",
  TASK_STATE_IDLE = "TASK_STATE_IDLE",
  TASK_STATE_PREEMPTIBLE = "TASK_STATE_PREEMPTIBLE",
  TASK_STATE_PREEMPTED = "TASK_STATE_PREEMPTED",
  TASK_STATE_LOADING_CHECKPOINT_IMAGE = "TASK_STATE_LOADING_CHECKPOINT_IMAGE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum TunnelType {
  TUNNEL_TYPE_UNSPECIFIED = "TUNNEL_TYPE_UNSPECIFIED",
  /** TUNNEL_TYPE_H2 - HTTP/2 tunnel */
  TUNNEL_TYPE_H2 = "TUNNEL_TYPE_H2",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum VolumeFsVersion {
  VOLUME_FS_VERSION_UNSPECIFIED = "VOLUME_FS_VERSION_UNSPECIFIED",
  VOLUME_FS_VERSION_V1 = "VOLUME_FS_VERSION_V1",
  VOLUME_FS_VERSION_V2 = "VOLUME_FS_VERSION_V2",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum WebhookAsyncMode {
  WEBHOOK_ASYNC_MODE_UNSPECIFIED = "WEBHOOK_ASYNC_MODE_UNSPECIFIED",
  /** WEBHOOK_ASYNC_MODE_DISABLED - No longer used by client */
  WEBHOOK_ASYNC_MODE_DISABLED = "WEBHOOK_ASYNC_MODE_DISABLED",
  /** WEBHOOK_ASYNC_MODE_TRIGGER - No longer used by client (previously used when wait_for_response=False) */
  WEBHOOK_ASYNC_MODE_TRIGGER = "WEBHOOK_ASYNC_MODE_TRIGGER",
  /** WEBHOOK_ASYNC_MODE_AUTO - The default */
  WEBHOOK_ASYNC_MODE_AUTO = "WEBHOOK_ASYNC_MODE_AUTO",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum WebhookType {
  WEBHOOK_TYPE_UNSPECIFIED = "WEBHOOK_TYPE_UNSPECIFIED",
  WEBHOOK_TYPE_ASGI_APP = "WEBHOOK_TYPE_ASGI_APP",
  WEBHOOK_TYPE_FUNCTION = "WEBHOOK_TYPE_FUNCTION",
  WEBHOOK_TYPE_WSGI_APP = "WEBHOOK_TYPE_WSGI_APP",
  WEBHOOK_TYPE_WEB_SERVER = "WEBHOOK_TYPE_WEB_SERVER",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface AppClientDisconnectRequest {
  appId: string;
  reason: AppDisconnectReason;
  exception: string;
}

export interface AppCreateRequest {
  clientId: string;
  /** Human readable label for the app */
  description: string;
  environmentName: string;
  appState: AppState;
}

export interface AppCreateResponse {
  appId: string;
  appPageUrl: string;
  appLogsUrl: string;
}

export interface AppDeployRequest {
  appId: string;
  namespace: DeploymentNamespace;
  name: string;
  objectEntity: string;
  visibility: AppDeployVisibility;
  tag: string;
}

export interface AppDeployResponse {
  url: string;
}

export interface AppDeploymentHistory {
  appId: string;
  version: number;
  clientVersion: string;
  deployedAt: number;
  deployedBy: string;
  deployedByAvatarUrl: string;
  tag: string;
  rollbackVersion: number;
  rollbackAllowed: boolean;
  commitInfo?: CommitInfo | undefined;
}

export interface AppDeploymentHistoryRequest {
  appId: string;
}

export interface AppDeploymentHistoryResponse {
  appDeploymentHistories: AppDeploymentHistory[];
}

export interface AppGetByDeploymentNameRequest {
  namespace: DeploymentNamespace;
  name: string;
  environmentName: string;
}

export interface AppGetByDeploymentNameResponse {
  appId: string;
}

export interface AppGetLayoutRequest {
  appId: string;
}

export interface AppGetLayoutResponse {
  appLayout: AppLayout | undefined;
}

export interface AppGetLogsRequest {
  appId: string;
  timeout: number;
  lastEntryId: string;
  functionId: string;
  inputId: string;
  taskId: string;
  functionCallId: string;
  fileDescriptor: FileDescriptor;
}

export interface AppGetObjectsItem {
  tag: string;
  object: Object | undefined;
}

export interface AppGetObjectsRequest {
  appId: string;
  includeUnindexed: boolean;
  /** True starting with 0.67.x clients, which don't create method placeholder functions */
  onlyClassFunction: boolean;
}

export interface AppGetObjectsResponse {
  items: AppGetObjectsItem[];
}

export interface AppGetOrCreateRequest {
  appName: string;
  environmentName: string;
  objectCreationType: ObjectCreationType;
}

export interface AppGetOrCreateResponse {
  appId: string;
}

export interface AppHeartbeatRequest {
  appId: string;
}

export interface AppLayout {
  objects: Object[];
  /** tag -> function id */
  functionIds: { [key: string]: string };
  /** tag -> class id */
  classIds: { [key: string]: string };
}

export interface AppLayout_FunctionIdsEntry {
  key: string;
  value: string;
}

export interface AppLayout_ClassIdsEntry {
  key: string;
  value: string;
}

export interface AppListRequest {
  environmentName: string;
}

export interface AppListResponse {
  apps: AppListResponse_AppListItem[];
}

export interface AppListResponse_AppListItem {
  appId: string;
  description: string;
  state: AppState;
  createdAt: number;
  stoppedAt: number;
  nRunningTasks: number;
  name: string;
}

export interface AppLookupRequest {
  appName: string;
  environmentName: string;
}

export interface AppLookupResponse {
  appId: string;
}

export interface AppPublishRequest {
  appId: string;
  name: string;
  /** Additional metadata to identify a deployment */
  deploymentTag: string;
  /** Published app will be in this state */
  appState: AppState;
  /** function_name -> function_id */
  functionIds: { [key: string]: string };
  /** class_name -> class_id */
  classIds: { [key: string]: string };
  /** function_id -> definition_id */
  definitionIds: { [key: string]: string };
  /** Unused by client, but used internally */
  rollbackVersion: number;
  /** Unused by client, but used internally */
  clientVersion: string;
  /** Git information for deployment tracking */
  commitInfo: CommitInfo | undefined;
}

export interface AppPublishRequest_FunctionIdsEntry {
  key: string;
  value: string;
}

export interface AppPublishRequest_ClassIdsEntry {
  key: string;
  value: string;
}

export interface AppPublishRequest_DefinitionIdsEntry {
  key: string;
  value: string;
}

export interface AppPublishResponse {
  url: string;
  serverWarnings: Warning[];
}

export interface AppRollbackRequest {
  appId: string;
  /** signed as we support negative "roll back n versions" requests */
  version: number;
}

export interface AppSetObjectsRequest {
  appId: string;
  indexedObjectIds: { [key: string]: string };
  clientId: string;
  unindexedObjectIds: string[];
  /** promotes an app from initializing to this new state */
  newAppState: AppState;
}

export interface AppSetObjectsRequest_IndexedObjectIdsEntry {
  key: string;
  value: string;
}

export interface AppStopRequest {
  appId: string;
  source: AppStopSource;
}

/**
 * A web endpoint connection-related message.
 *
 * Modal's internal web endpoint runtime effectively acts as a global web server
 * that schedules requests to tasks that are spawned on-demand, so we need an
 * internal protocol to model HTTP requests. This is that protocol.
 *
 * We base this protocol on Python's ASGI specification, which is a popular
 * interface between applications and web servers.
 *
 * ASGI Spec: https://asgi.readthedocs.io/en/latest/specs/www.html
 */
export interface Asgi {
  http?: Asgi_Http | undefined;
  httpRequest?: Asgi_HttpRequest | undefined;
  httpResponseStart?: Asgi_HttpResponseStart | undefined;
  httpResponseBody?: Asgi_HttpResponseBody | undefined;
  httpResponseTrailers?: Asgi_HttpResponseTrailers | undefined;
  httpDisconnect?: Asgi_HttpDisconnect | undefined;
  websocket?: Asgi_Websocket | undefined;
  websocketConnect?: Asgi_WebsocketConnect | undefined;
  websocketAccept?: Asgi_WebsocketAccept | undefined;
  websocketReceive?: Asgi_WebsocketReceive | undefined;
  websocketSend?: Asgi_WebsocketSend | undefined;
  websocketDisconnect?: Asgi_WebsocketDisconnect | undefined;
  websocketClose?: Asgi_WebsocketClose | undefined;
}

/** Message of type "http" (connection scope) */
export interface Asgi_Http {
  httpVersion: string;
  method: string;
  scheme: string;
  path: string;
  queryString: Uint8Array;
  /** Flat list of alternating header names and values */
  headers: Uint8Array[];
  clientHost?: string | undefined;
  clientPort?: number | undefined;
}

/** Message of type "http.request" */
export interface Asgi_HttpRequest {
  body: Uint8Array;
  moreBody: boolean;
}

/** Message of type "http.response.start" */
export interface Asgi_HttpResponseStart {
  status: number;
  /** Flat list of alternating header names and values */
  headers: Uint8Array[];
  trailers: boolean;
}

/** Message of type "http.response.body" */
export interface Asgi_HttpResponseBody {
  body: Uint8Array;
  moreBody: boolean;
}

/** Message of type "http.response.trailers" */
export interface Asgi_HttpResponseTrailers {
  /** Flat list of alternating header names and values */
  headers: Uint8Array[];
  moreTrailers: boolean;
}

/** Message of type "http.disconnect" */
export interface Asgi_HttpDisconnect {
}

/** Message of type "websocket" (connection scope) */
export interface Asgi_Websocket {
  /** We don't support RFC 8441 yet, so this will always be "1.1" */
  httpVersion: string;
  scheme: string;
  path: string;
  queryString: Uint8Array;
  /** Flat list of alternating header names and values */
  headers: Uint8Array[];
  clientHost?: string | undefined;
  clientPort?: number | undefined;
  subprotocols: string[];
}

/** Message of type "websocket.connect" */
export interface Asgi_WebsocketConnect {
}

/** Message of type "websocket.accept" */
export interface Asgi_WebsocketAccept {
  subprotocol?:
    | string
    | undefined;
  /** Flat list of alternating header names and values */
  headers: Uint8Array[];
}

/** Message of type "websocket.receive" */
export interface Asgi_WebsocketReceive {
  bytes?: Uint8Array | undefined;
  text?: string | undefined;
}

/** Message of type "websocket.send" */
export interface Asgi_WebsocketSend {
  bytes?: Uint8Array | undefined;
  text?: string | undefined;
}

/** Message of type "websocket.disconnect" */
export interface Asgi_WebsocketDisconnect {
  code?: number | undefined;
}

/** Message of type "websocket.close" */
export interface Asgi_WebsocketClose {
  code?: number | undefined;
  reason: string;
}

export interface AttemptAwaitRequest {
  attemptToken: string;
  /** Used for waypoints. */
  requestedAt: number;
  timeoutSecs: number;
}

export interface AttemptAwaitResponse {
  output?: FunctionGetOutputsItem | undefined;
}

export interface AttemptRetryRequest {
  functionId: string;
  parentInputId: string;
  input: FunctionPutInputsItem | undefined;
  attemptToken: string;
}

export interface AttemptRetryResponse {
  attemptToken: string;
}

export interface AttemptStartRequest {
  functionId: string;
  parentInputId: string;
  input: FunctionPutInputsItem | undefined;
}

export interface AttemptStartResponse {
  attemptToken: string;
  retryPolicy: FunctionRetryPolicy | undefined;
}

/**
 * A collection of user-configurable settings for Function autoscaling
 * These are used for static configuration and for dynamic autoscaler updates
 */
export interface AutoscalerSettings {
  /** Minimum containers when scale-to-zero is not deisired; pka "keep_warm" or "warm_pool_size" */
  minContainers?:
    | number
    | undefined;
  /** Limit on the number of containers that can be running for each Function; pka "concurrency_limit" */
  maxContainers?:
    | number
    | undefined;
  /** Additional container to spin up when Function is active */
  bufferContainers?:
    | number
    | undefined;
  /** Currently unused; a placeholder in case we decide to expose scaleup control to users */
  scaleupWindow?:
    | number
    | undefined;
  /** Maximum amount of time a container can be idle before being scaled down, in seconds; pka "container_idle_timeout" */
  scaledownWindow?: number | undefined;
}

export interface BaseImage {
  imageId: string;
  dockerTag: string;
}

export interface BlobCreateRequest {
  /**
   * TODO(erikbern): how are these garbage collected?
   * Shouldn't they belong to an app?
   */
  contentMd5: string;
  contentSha256Base64: string;
  contentLength: string;
}

export interface BlobCreateResponse {
  blobId: string;
  uploadUrl?: string | undefined;
  multipart?: MultiPartUpload | undefined;
}

export interface BlobGetRequest {
  blobId: string;
}

export interface BlobGetResponse {
  downloadUrl: string;
}

export interface BuildFunction {
  definition: string;
  globals: Uint8Array;
  input: FunctionInput | undefined;
}

export interface CancelInputEvent {
  inputIds: string[];
  terminateContainers: boolean;
}

export interface CheckpointInfo {
  checksum: string;
  status: CheckpointStatus;
  checkpointId: string;
  runtimeFingerprint: string;
  size: string;
  checksumIsFileIndex: boolean;
  originalTaskId: string;
  runscRuntimeVersion: string;
}

export interface ClassCreateRequest {
  appId: string;
  existingClassId: string;
  methods: ClassMethod[];
  /** True starting with 0.67.x clients, which don't create method placeholder functions */
  onlyClassFunction: boolean;
}

export interface ClassCreateResponse {
  classId: string;
  handleMetadata: ClassHandleMetadata | undefined;
}

export interface ClassGetRequest {
  appName: string;
  objectTag: string;
  namespace: DeploymentNamespace;
  environmentName: string;
  /** True starting with 0.67.x clients, which don't create method placeholder functions */
  onlyClassFunction: boolean;
}

export interface ClassGetResponse {
  classId: string;
  handleMetadata: ClassHandleMetadata | undefined;
  serverWarnings: Warning[];
}

export interface ClassHandleMetadata {
  methods: ClassMethod[];
  classFunctionId: string;
  classFunctionMetadata: FunctionHandleMetadata | undefined;
}

export interface ClassMethod {
  functionName: string;
  functionId: string;
  /** Class methods need to hydrate all functions on the class */
  functionHandleMetadata: FunctionHandleMetadata | undefined;
}

export interface ClassParameterInfo {
  format: ClassParameterInfo_ParameterSerializationFormat;
  /** only set for PARAM_SERIALIZATION_FORMAT_PROTO */
  schema: ClassParameterSpec[];
}

export enum ClassParameterInfo_ParameterSerializationFormat {
  PARAM_SERIALIZATION_FORMAT_UNSPECIFIED = "PARAM_SERIALIZATION_FORMAT_UNSPECIFIED",
  /** PARAM_SERIALIZATION_FORMAT_PICKLE - legacy format - pickle of (args, kwargs) tuple */
  PARAM_SERIALIZATION_FORMAT_PICKLE = "PARAM_SERIALIZATION_FORMAT_PICKLE",
  /** PARAM_SERIALIZATION_FORMAT_PROTO - new format using api.FunctionParameterSet */
  PARAM_SERIALIZATION_FORMAT_PROTO = "PARAM_SERIALIZATION_FORMAT_PROTO",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface ClassParameterSet {
  /**
   * NOTE: adding additional *fields* here can invalidate function lookups
   *  since we use the serialized message as the bound function identifier
   *  for parameter-bound classes. Modify with *caution*
   */
  parameters: ClassParameterValue[];
}

/** TODO: rename into NamedPayloadType or similar */
export interface ClassParameterSpec {
  name: string;
  /** TODO: deprecate - use full_type instead */
  type: ParameterType;
  hasDefault: boolean;
  /** Default *values* are only registered for class parameters */
  stringDefault?: string | undefined;
  intDefault?: string | undefined;
  pickleDefault?: Uint8Array | undefined;
  bytesDefault?: Uint8Array | undefined;
  boolDefault?:
    | boolean
    | undefined;
  /** supersedes `type` */
  fullType: GenericPayloadType | undefined;
}

/** TODO: rename into NamedPayloadValue */
export interface ClassParameterValue {
  /**
   * NOTE: adding additional *fields* here can invalidate function lookups
   *  since we use the serialized message as the bound function identifier
   *  for parameter-bound classes. Modify with *caution*
   */
  name: string;
  type: ParameterType;
  stringValue?: string | undefined;
  intValue?: string | undefined;
  pickleValue?: Uint8Array | undefined;
  bytesValue?: Uint8Array | undefined;
  boolValue?: boolean | undefined;
}

export interface ClientHelloResponse {
  warning: string;
  /** Deprecated, no longer used in client */
  imageBuilderVersion: string;
  serverWarnings: Warning[];
}

export interface CloudBucketMount {
  bucketName: string;
  mountPath: string;
  credentialsSecretId: string;
  readOnly: boolean;
  bucketType: CloudBucketMount_BucketType;
  requesterPays: boolean;
  bucketEndpointUrl?: string | undefined;
  keyPrefix?: string | undefined;
  oidcAuthRoleArn?: string | undefined;
}

export enum CloudBucketMount_BucketType {
  UNSPECIFIED = "UNSPECIFIED",
  S3 = "S3",
  R2 = "R2",
  GCP = "GCP",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface ClusterGetRequest {
  clusterId: string;
}

export interface ClusterGetResponse {
  cluster: ClusterStats | undefined;
}

export interface ClusterListRequest {
  environmentName: string;
}

export interface ClusterListResponse {
  clusters: ClusterStats[];
}

export interface ClusterStats {
  appId: string;
  taskIds: string[];
  clusterId: string;
  /** Defined as start time of the first task in the cluster */
  startedAt: number;
}

export interface CommitInfo {
  /** Only git is supported for now */
  vcs: string;
  branch: string;
  commitHash: string;
  commitTimestamp: string;
  dirty: boolean;
  authorName: string;
  authorEmail: string;
  repoUrl: string;
}

/** This is used to pass data from the worker to the container */
export interface ContainerArguments {
  taskId: string;
  functionId: string;
  appId: string;
  functionDef: Function | undefined;
  proxyInfo: ProxyInfo | undefined;
  tracingContext: { [key: string]: string };
  serializedParams: Uint8Array;
  runtime: string;
  environmentName: string;
  checkpointId?: string | undefined;
  appLayout: AppLayout | undefined;
}

export interface ContainerArguments_TracingContextEntry {
  key: string;
  value: string;
}

export interface ContainerCheckpointRequest {
  checkpointId: string;
}

export interface ContainerExecGetOutputRequest {
  execId: string;
  timeout: number;
  lastBatchIndex: string;
  fileDescriptor: FileDescriptor;
  /** Old clients (up to 0.65.39) expect string output. Newer clients stream raw bytes */
  getRawBytes: boolean;
}

export interface ContainerExecPutInputRequest {
  execId: string;
  input: RuntimeInputMessage | undefined;
}

export interface ContainerExecRequest {
  taskId: string;
  command: string[];
  /**
   * If pty_info is provided, open a PTY, but also this container exec is treated an
   * "interactive shell" request, and it will be terminated if messages are not periodically
   * sent on the stdin stream on some interval (currently 40 seconds).
   */
  ptyInfo?:
    | PTYInfo
    | undefined;
  /**
   * Send SIGTERM to running container on exit of exec command.
   *
   * @deprecated
   */
  terminateContainerOnExit: boolean;
  /** For internal debugging use only. */
  runtimeDebug: boolean;
  stdoutOutput: ExecOutputOption;
  stderrOutput: ExecOutputOption;
  timeoutSecs: number;
  workdir?: string | undefined;
  secretIds: string[];
}

export interface ContainerExecResponse {
  execId: string;
}

export interface ContainerExecWaitRequest {
  execId: string;
  timeout: number;
}

export interface ContainerExecWaitResponse {
  exitCode?: number | undefined;
  completed: boolean;
}

export interface ContainerFileCloseRequest {
  fileDescriptor: string;
}

export interface ContainerFileDeleteBytesRequest {
  fileDescriptor: string;
  startInclusive?: number | undefined;
  endExclusive?: number | undefined;
}

export interface ContainerFileFlushRequest {
  fileDescriptor: string;
}

export interface ContainerFileLsRequest {
  path: string;
}

export interface ContainerFileMkdirRequest {
  path: string;
  makeParents: boolean;
}

export interface ContainerFileOpenRequest {
  /** file descriptor is hydrated when sent from server -> worker */
  fileDescriptor?: string | undefined;
  path: string;
  mode: string;
}

export interface ContainerFileReadLineRequest {
  fileDescriptor: string;
}

export interface ContainerFileReadRequest {
  fileDescriptor: string;
  n?: number | undefined;
}

export interface ContainerFileRmRequest {
  path: string;
  recursive: boolean;
}

export interface ContainerFileSeekRequest {
  fileDescriptor: string;
  offset: number;
  whence: SeekWhence;
}

export interface ContainerFileWatchRequest {
  path: string;
  recursive: boolean;
  timeoutSecs?: string | undefined;
}

export interface ContainerFileWriteReplaceBytesRequest {
  fileDescriptor: string;
  data: Uint8Array;
  startInclusive?: number | undefined;
  endExclusive?: number | undefined;
}

export interface ContainerFileWriteRequest {
  fileDescriptor: string;
  data: Uint8Array;
}

export interface ContainerFilesystemExecGetOutputRequest {
  execId: string;
  timeout: number;
}

export interface ContainerFilesystemExecRequest {
  fileOpenRequest?: ContainerFileOpenRequest | undefined;
  fileWriteRequest?: ContainerFileWriteRequest | undefined;
  fileReadRequest?: ContainerFileReadRequest | undefined;
  fileFlushRequest?: ContainerFileFlushRequest | undefined;
  fileReadLineRequest?: ContainerFileReadLineRequest | undefined;
  fileSeekRequest?: ContainerFileSeekRequest | undefined;
  fileDeleteBytesRequest?: ContainerFileDeleteBytesRequest | undefined;
  fileWriteReplaceBytesRequest?: ContainerFileWriteReplaceBytesRequest | undefined;
  fileCloseRequest?: ContainerFileCloseRequest | undefined;
  fileLsRequest?: ContainerFileLsRequest | undefined;
  fileMkdirRequest?: ContainerFileMkdirRequest | undefined;
  fileRmRequest?: ContainerFileRmRequest | undefined;
  fileWatchRequest?: ContainerFileWatchRequest | undefined;
  taskId: string;
}

export interface ContainerFilesystemExecResponse {
  execId: string;
  /** only set when the request opens a new file, i.e., ContainerFileOpenRequest */
  fileDescriptor?: string | undefined;
}

export interface ContainerHeartbeatRequest {
  /** Bad client version. */
  canceledInputsReturnOutputs: boolean;
  canceledInputsReturnOutputsV2: boolean;
}

export interface ContainerHeartbeatResponse {
  cancelInputEvent?: CancelInputEvent | undefined;
}

export interface ContainerLogRequest {
  logs: TaskLogs[];
}

export interface ContainerStopRequest {
  taskId: string;
}

export interface ContainerStopResponse {
}

export interface CustomDomainConfig {
  name: string;
}

export interface CustomDomainInfo {
  url: string;
}

export interface DNSRecord {
  type: DNSRecordType;
  name: string;
  value: string;
}

/** Chunks of data that can be streamed in and out of tasks. */
export interface DataChunk {
  dataFormat: DataFormat;
  data?: Uint8Array | undefined;
  dataBlobId?:
    | string
    | undefined;
  /** Index of this data chunk in the stream. */
  index: string;
}

export interface DictClearRequest {
  dictId: string;
}

export interface DictContainsRequest {
  dictId: string;
  key: Uint8Array;
}

export interface DictContainsResponse {
  found: boolean;
}

export interface DictContentsRequest {
  dictId: string;
  /**
   * Setting these to True will populate the corresponding field in the response, otherwise it will be null
   * This lets us support the keys/values/items SDK API through one RPC without unnecessary data transfer
   */
  keys: boolean;
  values: boolean;
}

export interface DictDeleteRequest {
  dictId: string;
}

export interface DictEntry {
  key: Uint8Array;
  value: Uint8Array;
}

export interface DictGetOrCreateRequest {
  deploymentName: string;
  namespace: DeploymentNamespace;
  environmentName: string;
  objectCreationType: ObjectCreationType;
  data: DictEntry[];
}

export interface DictGetOrCreateResponse {
  dictId: string;
}

export interface DictGetRequest {
  dictId: string;
  key: Uint8Array;
}

export interface DictGetResponse {
  found: boolean;
  value?: Uint8Array | undefined;
}

export interface DictHeartbeatRequest {
  dictId: string;
}

export interface DictLenRequest {
  dictId: string;
}

export interface DictLenResponse {
  len: number;
}

export interface DictListRequest {
  environmentName: string;
}

export interface DictListResponse {
  dicts: DictListResponse_DictInfo[];
}

export interface DictListResponse_DictInfo {
  name: string;
  createdAt: number;
}

export interface DictPopRequest {
  dictId: string;
  key: Uint8Array;
}

export interface DictPopResponse {
  found: boolean;
  value?: Uint8Array | undefined;
}

export interface DictUpdateRequest {
  dictId: string;
  updates: DictEntry[];
  ifNotExists: boolean;
}

export interface DictUpdateResponse {
  created: boolean;
}

export interface Domain {
  domainId: string;
  domainName: string;
  createdAt: number;
  certificateStatus: CertificateStatus;
  dnsRecords: DNSRecord[];
}

export interface DomainCertificateVerifyRequest {
  domainId: string;
}

export interface DomainCertificateVerifyResponse {
  domain: Domain | undefined;
}

export interface DomainCreateRequest {
  domainName: string;
}

export interface DomainCreateResponse {
  domainId: string;
  dnsRecords: DNSRecord[];
}

export interface DomainListRequest {
}

export interface DomainListResponse {
  domains: Domain[];
}

export interface EnvironmentCreateRequest {
  name: string;
}

export interface EnvironmentDeleteRequest {
  name: string;
}

export interface EnvironmentGetOrCreateRequest {
  deploymentName: string;
  objectCreationType: ObjectCreationType;
}

export interface EnvironmentGetOrCreateResponse {
  environmentId: string;
  metadata: EnvironmentMetadata | undefined;
}

export interface EnvironmentListItem {
  name: string;
  webhookSuffix: string;
  createdAt: number;
  default: boolean;
}

export interface EnvironmentListResponse {
  items: EnvironmentListItem[];
}

export interface EnvironmentMetadata {
  name: string;
  settings: EnvironmentSettings | undefined;
}

/**
 * Environment-scoped settings, with workspace-level defaults.
 * Note that we use MergeFrom to combine workspace / environment settings,
 * which will *append* any `repeated` fields!
 */
export interface EnvironmentSettings {
  imageBuilderVersion: string;
  webhookSuffix: string;
}

export interface EnvironmentUpdateRequest {
  currentName: string;
  name: string | undefined;
  webSuffix: string | undefined;
}

/** A file entry when listing files in a volume or network file system. */
export interface FileEntry {
  path: string;
  type: FileEntry_FileType;
  mtime: string;
  size: string;
}

export enum FileEntry_FileType {
  UNSPECIFIED = "UNSPECIFIED",
  FILE = "FILE",
  DIRECTORY = "DIRECTORY",
  SYMLINK = "SYMLINK",
  FIFO = "FIFO",
  SOCKET = "SOCKET",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface FilesystemRuntimeOutputBatch {
  output: Uint8Array[];
  error?: SystemErrorMessage | undefined;
  batchIndex: string;
  eof: boolean;
}

export interface Function {
  moduleName: string;
  functionName: string;
  mountIds: string[];
  imageId: string;
  functionSerialized: Uint8Array;
  definitionType: Function_DefinitionType;
  functionType: Function_FunctionType;
  resources: Resources | undefined;
  secretIds: string[];
  rateLimit: RateLimit | undefined;
  webhookConfig: WebhookConfig | undefined;
  sharedVolumeMounts: SharedVolumeMount[];
  proxyId?: string | undefined;
  retryPolicy:
    | FunctionRetryPolicy
    | undefined;
  /** To be replaced by autoscaler_settings.max_containers */
  concurrencyLimit: number;
  timeoutSecs: number;
  ptyInfo: PTYInfo | undefined;
  classSerialized: Uint8Array;
  /** To be replaced by autoscaler_settings.scaledown_period */
  taskIdleTimeoutSecs: number;
  /** Deprecated at some point */
  cloudProvider?:
    | CloudProvider
    | undefined;
  /** To be replaced by autoscaler_settings.min_containers */
  warmPoolSize: number;
  webUrl: string;
  webUrlInfo:
    | WebUrlInfo
    | undefined;
  /** If set, overrides the runtime used by the function, either "runc" or "gvisor". */
  runtime: string;
  /** Formerly stub_name */
  appName: string;
  volumeMounts: VolumeMount[];
  maxConcurrentInputs: number;
  customDomainInfo: CustomDomainInfo[];
  /** For internal debugging use only. */
  workerId: string;
  /** For internal debugging use only. */
  runtimeDebug: boolean;
  /** TODO: combine into enum? */
  isBuilderFunction: boolean;
  isAutoSnapshot: boolean;
  isMethod: boolean;
  isCheckpointingFunction: boolean;
  checkpointingEnabled: boolean;
  checkpoint: CheckpointInfo | undefined;
  objectDependencies: ObjectDependency[];
  blockNetwork: boolean;
  maxInputs: number;
  s3Mounts: S3Mount[];
  cloudBucketMounts: CloudBucketMount[];
  schedulerPlacement?:
    | SchedulerPlacement
    | undefined;
  /** if "Function" is actually a class grouping multiple methods */
  isClass: boolean;
  /** for class methods use this function id instead for invocations - the *referenced* function should have is_class=True */
  useFunctionId: string;
  /** for class methods - this method name needs to be included in the FunctionInput */
  useMethodName: string;
  classParameterInfo:
    | ClassParameterInfo
    | undefined;
  /** Maximum number of inputs to fetch at once */
  batchMaxSize: number;
  /** Miliseconds to block before a response is needed */
  batchLingerMs: string;
  i6pnEnabled: boolean;
  ExperimentalConcurrentCancellations: boolean;
  targetConcurrentInputs: number;
  /** TODO(irfansharif): Remove, once https://github.com/modal-labs/modal/pull/15645 lands. */
  ExperimentalTaskTemplatesEnabled: boolean;
  /** for fallback options, where the first/most-preferred "template" is derived from fields above */
  ExperimentalTaskTemplates: TaskTemplate[];
  /**
   * When the function is a "grouped" one, this records the # of tasks we want
   * to schedule in tandem.
   */
  ExperimentalGroupSize: number;
  /** If set, the function will be run in an untrusted environment. */
  untrusted: boolean;
  /** To be replaced by autoscaler_settings.buffer_containers */
  ExperimentalBufferContainers: number;
  /**
   * _experimental_proxy_ip -> ProxyInfo
   * TODO: deprecate.
   */
  ExperimentalProxyIp?:
    | string
    | undefined;
  /** For internal debugging use only. */
  runtimePerfRecord: boolean;
  schedule:
    | Schedule
    | undefined;
  /** For internal debugging use only. */
  snapshotDebug: boolean;
  /** Mapping of method names to method definitions, only non-empty for class service functions */
  methodDefinitions: { [key: string]: MethodDefinition };
  methodDefinitionsSet: boolean;
  ExperimentalCustomScaling: boolean;
  /** Supersedes cloud_provider */
  cloudProviderStr: string;
  /** Experimental support for GPU snapshotting */
  ExperimentalEnableGpuSnapshot: boolean;
  /** Bundle of parameters related to autoscaling */
  autoscalerSettings: AutoscalerSettings | undefined;
  functionSchema:
    | FunctionSchema
    | undefined;
  /**
   * For server-side experimental functionality. Prefer using this over individual _experimental_* fields.
   * Note the value type as string. Internally we'll coerce all values to string with str().
   * On the server, it's necessary to convert back to the most natural type (e.g. int) when relevant.
   */
  experimentalOptions: { [key: string]: string };
  /**
   * If set, client deps will be mounted into the container, and are
   * no longer expected to exist in the image itself.
   */
  mountClientDependencies: boolean;
}

export enum Function_DefinitionType {
  DEFINITION_TYPE_UNSPECIFIED = "DEFINITION_TYPE_UNSPECIFIED",
  DEFINITION_TYPE_SERIALIZED = "DEFINITION_TYPE_SERIALIZED",
  DEFINITION_TYPE_FILE = "DEFINITION_TYPE_FILE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum Function_FunctionType {
  FUNCTION_TYPE_UNSPECIFIED = "FUNCTION_TYPE_UNSPECIFIED",
  FUNCTION_TYPE_GENERATOR = "FUNCTION_TYPE_GENERATOR",
  FUNCTION_TYPE_FUNCTION = "FUNCTION_TYPE_FUNCTION",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface Function_MethodDefinitionsEntry {
  key: string;
  value: MethodDefinition | undefined;
}

export interface Function_ExperimentalOptionsEntry {
  key: string;
  value: string;
}

export interface FunctionAsyncInvokeRequest {
  functionId: string;
  parentInputId: string;
  input: FunctionInput | undefined;
}

export interface FunctionAsyncInvokeResponse {
  retryWithBlobUpload: boolean;
  functionCallId: string;
}

export interface FunctionBindParamsRequest {
  functionId: string;
  serializedParams: Uint8Array;
  functionOptions: FunctionOptions | undefined;
  environmentName: string;
}

export interface FunctionBindParamsResponse {
  boundFunctionId: string;
  handleMetadata: FunctionHandleMetadata | undefined;
}

export interface FunctionCallCallGraphInfo {
  functionCallId: string;
  parentInputId: string;
  functionName: string;
  moduleName: string;
}

export interface FunctionCallCancelRequest {
  functionCallId: string;
  terminateContainers: boolean;
}

export interface FunctionCallGetDataRequest {
  functionCallId: string;
  lastIndex: string;
}

export interface FunctionCallInfo {
  functionCallId: string;
  idx: number;
  /** when the call was created */
  createdAt: number;
  /** if cron job, when run was scheduled */
  scheduledAt: number;
  pendingInputs: InputCategoryInfo | undefined;
  failedInputs: InputCategoryInfo | undefined;
  succeededInputs: InputCategoryInfo | undefined;
  timeoutInputs: InputCategoryInfo | undefined;
  cancelledInputs: InputCategoryInfo | undefined;
  totalInputs: number;
}

export interface FunctionCallListRequest {
  functionId: string;
}

export interface FunctionCallListResponse {
  functionCalls: FunctionCallInfo[];
}

export interface FunctionCallPutDataRequest {
  functionCallId: string;
  dataChunks: DataChunk[];
}

export interface FunctionCreateRequest {
  function: Function | undefined;
  appId: string;
  /**
   * Deprecated: now passed in the Function definition
   *
   * @deprecated
   */
  schedule: Schedule | undefined;
  existingFunctionId: string;
  /** supersedes 'function' field above */
  functionData: FunctionData | undefined;
}

export interface FunctionCreateResponse {
  functionId: string;
  /**
   * Used up until 0.62.212
   *
   * @deprecated
   */
  DeprecatedWebUrl: string;
  function: Function | undefined;
  handleMetadata: FunctionHandleMetadata | undefined;
  serverWarnings: Warning[];
}

/**
 * Note: FunctionData pulls "up" a subset of fields from Function message that
 * will get deprecated there and made authoritative here, at the top-level.
 * All remaining fields will stay within the Function message itself and a
 * single FunctionData will contain a list of such (ranked) Functions. The
 * top-level fields capture data not specific to any particular underlying
 * task (like warm-pool-size, applicable across all tasks), while fields
 * specific to the task (like the resource request) will exist at the bottom
 * level.
 */
export interface FunctionData {
  moduleName: string;
  functionName: string;
  functionType: Function_FunctionType;
  /** Scheduling related fields. */
  warmPoolSize: number;
  concurrencyLimit: number;
  taskIdleTimeoutSecs: number;
  /**
   * When the function is a "grouped" one, this records the # of tasks we want
   * to schedule in tandem.
   */
  ExperimentalGroupSize: number;
  ExperimentalBufferContainers: number;
  ExperimentalCustomScaling: boolean;
  ExperimentalEnableGpuSnapshot: boolean;
  /** for internal debugging use only */
  workerId: string;
  timeoutSecs: number;
  webUrl: string;
  webUrlInfo: WebUrlInfo | undefined;
  webhookConfig: WebhookConfig | undefined;
  customDomainInfo: CustomDomainInfo[];
  /**
   * _experimental_proxy_ip -> ProxyInfo
   * TODO: deprecate.
   */
  ExperimentalProxyIp?:
    | string
    | undefined;
  /** Mapping of method names to method definitions, only non-empty for class service functions */
  methodDefinitions: { [key: string]: MethodDefinition };
  methodDefinitionsSet: boolean;
  /** if "Function" is actually a class grouping multiple methods - applies across all underlying tasks */
  isClass: boolean;
  classParameterInfo: ClassParameterInfo | undefined;
  isMethod: boolean;
  /** used for methods */
  useFunctionId: string;
  /** used for methods */
  useMethodName: string;
  rankedFunctions: FunctionData_RankedFunction[];
  schedule:
    | Schedule
    | undefined;
  /** If set, the function will be run in an untrusted environment. */
  untrusted: boolean;
  /** For internal debugging use only. */
  snapshotDebug: boolean;
  /** For internal debugging use only. */
  runtimePerfRecord: boolean;
  /** Bundle of parameters related to autoscaling */
  autoscalerSettings: AutoscalerSettings | undefined;
  functionSchema: FunctionSchema | undefined;
  experimentalOptions: { [key: string]: string };
}

export interface FunctionData_MethodDefinitionsEntry {
  key: string;
  value: MethodDefinition | undefined;
}

export interface FunctionData_RankedFunction {
  rank: number;
  function: Function | undefined;
}

export interface FunctionData_ExperimentalOptionsEntry {
  key: string;
  value: string;
}

export interface FunctionExtended {
  typeIdentifier: number;
  functionSingleton?: Function | undefined;
  functionData?: FunctionData | undefined;
}

export interface FunctionGetCallGraphRequest {
  /** TODO: use input_id once we switch client submit API to return those. */
  functionCallId: string;
}

export interface FunctionGetCallGraphResponse {
  inputs: InputCallGraphInfo[];
  functionCalls: FunctionCallCallGraphInfo[];
}

export interface FunctionGetCurrentStatsRequest {
  functionId: string;
}

export interface FunctionGetDynamicConcurrencyRequest {
  functionId: string;
  targetConcurrency: number;
  maxConcurrency: number;
}

export interface FunctionGetDynamicConcurrencyResponse {
  concurrency: number;
}

export interface FunctionGetInputsItem {
  inputId: string;
  input: FunctionInput | undefined;
  killSwitch: boolean;
  functionCallId: string;
  functionCallInvocationType: FunctionCallInvocationType;
  retryCount: number;
}

export interface FunctionGetInputsRequest {
  functionId: string;
  maxValues: number;
  averageCallTime: number;
  /** Container aims to fetch multiple inputs at the same time */
  inputConcurrency: number;
  /** Maximum number of inputs to fetch at once */
  batchMaxSize: number;
  /** Miliseconds to block before a response is needed */
  batchLingerMs: string;
}

export interface FunctionGetInputsResponse {
  inputs: FunctionGetInputsItem[];
  /** How long to sleep before requesting another input. */
  rateLimitSleepDuration: number;
}

export interface FunctionGetOutputsItem {
  result: GenericResult | undefined;
  idx: number;
  inputId: string;
  /** for result.data_oneof */
  dataFormat: DataFormat;
  taskId: string;
  inputStartedAt: number;
  outputCreatedAt: number;
  retryCount: number;
  /** datadog function call trace tag */
  fcTraceTag: string;
}

export interface FunctionGetOutputsRequest {
  functionCallId: string;
  maxValues: number;
  timeout: number;
  lastEntryId: string;
  /** expires *any* remaining outputs soon after this call, not just the returned ones */
  clearOnSuccess: boolean;
  /** Used for waypoints. */
  requestedAt: number;
  /** The jwts the client expects the server to be processing. This is optional and used for sync inputs only. */
  inputJwts: string[];
}

export interface FunctionGetOutputsResponse {
  idxs: number[];
  outputs: FunctionGetOutputsItem[];
  lastEntryId: string;
  numUnfinishedInputs: number;
}

export interface FunctionGetRequest {
  appName: string;
  objectTag: string;
  namespace: DeploymentNamespace;
  environmentName: string;
}

export interface FunctionGetResponse {
  functionId: string;
  handleMetadata: FunctionHandleMetadata | undefined;
  serverWarnings: Warning[];
}

export interface FunctionGetSerializedRequest {
  functionId: string;
}

export interface FunctionGetSerializedResponse {
  functionSerialized: Uint8Array;
  classSerialized: Uint8Array;
}

/**
 * contains all the info about a function that is needed to trigger the right
 * behaviour when using a FunctionHandler. Notably excludes things purely
 * used for *executing* the function in a container entrypoint
 */
export interface FunctionHandleMetadata {
  /** Should be a subset and use IDs/types from `Function` above */
  functionName: string;
  functionType: Function_FunctionType;
  webUrl: string;
  isMethod: boolean;
  /** used for methods */
  useFunctionId: string;
  /** used for methods */
  useMethodName: string;
  definitionId: string;
  classParameterInfo:
    | ClassParameterInfo
    | undefined;
  /** Mapping of method names to their metadata, only non-empty for class service functions */
  methodHandleMetadata: { [key: string]: FunctionHandleMetadata };
  functionSchema: FunctionSchema | undefined;
  inputPlaneUrl?: string | undefined;
}

export interface FunctionHandleMetadata_MethodHandleMetadataEntry {
  key: string;
  value: FunctionHandleMetadata | undefined;
}

export interface FunctionInput {
  args?: Uint8Array | undefined;
  argsBlobId?: string | undefined;
  finalInput: boolean;
  /** For args_oneof. */
  dataFormat: DataFormat;
  /** specifies which method to call when calling a class/object function */
  methodName?: string | undefined;
}

export interface FunctionMapRequest {
  functionId: string;
  parentInputId: string;
  returnExceptions: boolean;
  functionCallType: FunctionCallType;
  pipelinedInputs: FunctionPutInputsItem[];
  functionCallInvocationType: FunctionCallInvocationType;
  fromSpawnMap: boolean;
}

export interface FunctionMapResponse {
  functionCallId: string;
  pipelinedInputs: FunctionPutInputsResponseItem[];
  retryPolicy: FunctionRetryPolicy | undefined;
  functionCallJwt: string;
  syncClientRetriesEnabled: boolean;
  maxInputsOutstanding: number;
}

export interface FunctionOptions {
  secretIds: string[];
  /** Currently not supported */
  mountIds: string[];
  resources?: Resources | undefined;
  retryPolicy?: FunctionRetryPolicy | undefined;
  concurrencyLimit?: number | undefined;
  timeoutSecs?: number | undefined;
  taskIdleTimeoutSecs?: number | undefined;
  warmPoolSize?: number | undefined;
  volumeMounts: VolumeMount[];
  targetConcurrentInputs?: number | undefined;
  replaceVolumeMounts: boolean;
  replaceSecretIds: boolean;
  bufferContainers?: number | undefined;
  maxConcurrentInputs?: number | undefined;
  batchMaxSize?: number | undefined;
  batchLingerMs?: string | undefined;
}

export interface FunctionPrecreateRequest {
  appId: string;
  functionName: string;
  existingFunctionId: string;
  functionType: Function_FunctionType;
  webhookConfig:
    | WebhookConfig
    | undefined;
  /** for class methods - use this function id instead for invocations - the *referenced* function should have is_class=True */
  useFunctionId: string;
  /** for class methods - this method name needs to be included in the FunctionInput */
  useMethodName: string;
  /** Mapping of method names to method definitions, only non-empty for class service functions */
  methodDefinitions: { [key: string]: MethodDefinition };
  functionSchema: FunctionSchema | undefined;
}

export interface FunctionPrecreateRequest_MethodDefinitionsEntry {
  key: string;
  value: MethodDefinition | undefined;
}

export interface FunctionPrecreateResponse {
  functionId: string;
  handleMetadata: FunctionHandleMetadata | undefined;
}

export interface FunctionPutInputsItem {
  idx: number;
  input: FunctionInput | undefined;
}

export interface FunctionPutInputsRequest {
  functionId: string;
  functionCallId: string;
  inputs: FunctionPutInputsItem[];
}

export interface FunctionPutInputsResponse {
  inputs: FunctionPutInputsResponseItem[];
}

export interface FunctionPutInputsResponseItem {
  idx: number;
  inputId: string;
  inputJwt: string;
}

export interface FunctionPutOutputsItem {
  inputId: string;
  result: GenericResult | undefined;
  inputStartedAt: number;
  outputCreatedAt: number;
  /** for result.data_oneof */
  dataFormat: DataFormat;
  retryCount: number;
}

export interface FunctionPutOutputsRequest {
  outputs: FunctionPutOutputsItem[];
  /** Used for waypoints. */
  requestedAt: number;
}

export interface FunctionRetryInputsItem {
  inputJwt: string;
  input: FunctionInput | undefined;
  retryCount: number;
}

export interface FunctionRetryInputsRequest {
  functionCallJwt: string;
  inputs: FunctionRetryInputsItem[];
}

export interface FunctionRetryInputsResponse {
  inputJwts: string[];
}

export interface FunctionRetryPolicy {
  backoffCoefficient: number;
  initialDelayMs: number;
  maxDelayMs: number;
  /** NOTE: two-byte field number not used for special reason. copy-paste error. Ref: PR #2542 */
  retries: number;
}

export interface FunctionSchema {
  /** allows easy disambiguation between empty schema and no schema collection etc. */
  schemaType: FunctionSchema_FunctionSchemaType;
  arguments: ClassParameterSpec[];
  returnType: GenericPayloadType | undefined;
}

export enum FunctionSchema_FunctionSchemaType {
  FUNCTION_SCHEMA_UNSPECIFIED = "FUNCTION_SCHEMA_UNSPECIFIED",
  FUNCTION_SCHEMA_V1 = "FUNCTION_SCHEMA_V1",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface FunctionStats {
  backlog: number;
  numTotalTasks: number;
}

export interface FunctionUpdateSchedulingParamsRequest {
  functionId: string;
  warmPoolSizeOverride: number;
  settings: AutoscalerSettings | undefined;
}

export interface FunctionUpdateSchedulingParamsResponse {
}

export interface GPUConfig {
  /** Deprecated, at some point */
  type: GPUType;
  count: number;
  gpuType: string;
}

/** Sent as the output when a generator finishes running. */
export interface GeneratorDone {
  itemsTotal: string;
}

export interface GenericPayloadType {
  baseType: ParameterType;
  /** sub-type for generic types like lists */
  subTypes: GenericPayloadType[];
}

/** Used for both tasks and function outputs */
export interface GenericResult {
  /** Status of the task or function output. */
  status: GenericResult_GenericStatus;
  /** Exception message for failures, if available. */
  exception: string;
  /** Status code of the container entrypoint or builder process if it terminates unexpectedly. */
  exitcode: number;
  /** String value of the Python traceback. */
  traceback: string;
  /** Pickled traceback object. */
  serializedTb: Uint8Array;
  /** Pickled line cache for traceback object. */
  tbLineCache: Uint8Array;
  /** Inline data of the result. */
  data?:
    | Uint8Array
    | undefined;
  /** Blob ID for large data. */
  dataBlobId?:
    | string
    | undefined;
  /** (?) */
  propagationReason: string;
}

export enum GenericResult_GenericStatus {
  GENERIC_STATUS_UNSPECIFIED = "GENERIC_STATUS_UNSPECIFIED",
  GENERIC_STATUS_SUCCESS = "GENERIC_STATUS_SUCCESS",
  GENERIC_STATUS_FAILURE = "GENERIC_STATUS_FAILURE",
  /** GENERIC_STATUS_TERMINATED - Used when a task was killed using an external signal. */
  GENERIC_STATUS_TERMINATED = "GENERIC_STATUS_TERMINATED",
  GENERIC_STATUS_TIMEOUT = "GENERIC_STATUS_TIMEOUT",
  /**
   * GENERIC_STATUS_INIT_FAILURE - Used when the user's function fails to initialize (ex. S3 mount failed due to invalid credentials).
   * Terminates the function and all remaining inputs.
   */
  GENERIC_STATUS_INIT_FAILURE = "GENERIC_STATUS_INIT_FAILURE",
  GENERIC_STATUS_INTERNAL_FAILURE = "GENERIC_STATUS_INTERNAL_FAILURE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface Image {
  baseImages: BaseImage[];
  dockerfileCommands: string[];
  contextFiles: ImageContextFile[];
  version: string;
  secretIds: string[];
  /**
   * Part of Image definition, because presence of GPU drivers
   * affects the image that's built.
   */
  contextMountId: string;
  gpuConfig: GPUConfig | undefined;
  imageRegistryConfig:
    | ImageRegistryConfig
    | undefined;
  /** deprecated after 0.58.96 */
  buildFunctionDef: string;
  /** deprecated after 0.58.96 */
  buildFunctionGlobals: Uint8Array;
  /** If set, overrides the runtime used by the function. Specify either "runc" or "gvisor". */
  runtime: string;
  /** Not included in image definition checksum as debug features do not affect built image. */
  runtimeDebug: boolean;
  buildFunction: BuildFunction | undefined;
}

export interface ImageContextFile {
  filename: string;
  data: Uint8Array;
}

export interface ImageFromIdRequest {
  imageId: string;
}

export interface ImageFromIdResponse {
  imageId: string;
  metadata: ImageMetadata | undefined;
}

export interface ImageGetOrCreateRequest {
  image: Image | undefined;
  appId: string;
  /** ignored */
  existingImageId: string;
  buildFunctionId: string;
  forceBuild: boolean;
  namespace: DeploymentNamespace;
  builderVersion: string;
  /** Only admins can publish global images, but this provides an extra failsafe */
  allowGlobalDeployment: boolean;
  /** Force the Image to build but don't clobber any Images with the same recipe in the cache */
  ignoreCache: boolean;
}

export interface ImageGetOrCreateResponse {
  /** image_id is set regardless if the image is built (use ImageJoinStreaming to wait for build) */
  imageId: string;
  /** result of build - only set if the image has finished building (regardless if success or not) */
  result:
    | GenericResult
    | undefined;
  /** image metadata - only set if the image has built successfully */
  metadata: ImageMetadata | undefined;
}

export interface ImageJoinStreamingRequest {
  imageId: string;
  timeout: number;
  lastEntryId: string;
  includeLogsForFinished: boolean;
}

export interface ImageJoinStreamingResponse {
  result: GenericResult | undefined;
  taskLogs: TaskLogs[];
  entryId: string;
  eof: boolean;
  /** set on success */
  metadata: ImageMetadata | undefined;
}

export interface ImageMetadata {
  /** The output of `python -VV. Not set if missing */
  pythonVersionInfo?:
    | string
    | undefined;
  /**
   * Installed python packages, as listed by by `pip list`.
   * package name -> version. Empty if missing
   */
  pythonPackages: { [key: string]: string };
  /**
   * The working directory of the image, as an absolute file path.
   *
   * For most images, this is not set, which means to use the default workdir:
   * - On function runners, the default is `/root` (home directory).
   * - For image builds and sandbox environments, it is `/`.
   */
  workdir?:
    | string
    | undefined;
  /** The version of glibc in this image, if any. */
  libcVersionInfo?:
    | string
    | undefined;
  /** The builder version for/with which the image was created. */
  imageBuilderVersion?: string | undefined;
}

export interface ImageMetadata_PythonPackagesEntry {
  key: string;
  value: string;
}

export interface ImageRegistryConfig {
  registryAuthType: RegistryAuthType;
  secretId: string;
}

export interface InputCallGraphInfo {
  inputId: string;
  status: GenericResult_GenericStatus;
  functionCallId: string;
  taskId: string;
}

export interface InputCategoryInfo {
  total: number;
  latest: InputInfo[];
}

export interface InputInfo {
  inputId: string;
  idx: number;
  taskId: string;
  startedAt: number;
  finishedAt: number;
  taskStartupTime: number;
  taskFirstInput: boolean;
}

export interface MethodDefinition {
  functionName: string;
  functionType: Function_FunctionType;
  webhookConfig: WebhookConfig | undefined;
  webUrl: string;
  webUrlInfo: WebUrlInfo | undefined;
  customDomainInfo: CustomDomainInfo[];
  functionSchema: FunctionSchema | undefined;
}

export interface MountFile {
  filename: string;
  /** SHA-256 checksum of the file. */
  sha256Hex: string;
  /** Size of the file in bytes — ignored in MountBuild(). */
  size?:
    | string
    | undefined;
  /** Unix file permission bits `st_mode`. */
  mode?: number | undefined;
}

export interface MountGetOrCreateRequest {
  deploymentName: string;
  namespace: DeploymentNamespace;
  environmentName: string;
  objectCreationType: ObjectCreationType;
  files: MountFile[];
  /** only used with OBJECT_CREATION_TYPE_ANONYMOUS_OWNED_BY_APP */
  appId: string;
}

export interface MountGetOrCreateResponse {
  mountId: string;
  handleMetadata: MountHandleMetadata | undefined;
}

export interface MountHandleMetadata {
  contentChecksumSha256Hex: string;
}

export interface MountPutFileRequest {
  sha256Hex: string;
  data?: Uint8Array | undefined;
  dataBlobId?: string | undefined;
}

export interface MountPutFileResponse {
  exists: boolean;
}

export interface MultiPartUpload {
  /** split upload based on this part length - all except the last part must have this length */
  partLength: string;
  uploadUrls: string[];
  completionUrl: string;
}

export interface NetworkAccess {
  networkAccessType: NetworkAccess_NetworkAccessType;
  allowedCidrs: string[];
}

export enum NetworkAccess_NetworkAccessType {
  UNSPECIFIED = "UNSPECIFIED",
  OPEN = "OPEN",
  BLOCKED = "BLOCKED",
  ALLOWLIST = "ALLOWLIST",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface NotebookKernelPublishResultsRequest {
  notebookId: string;
  results: NotebookKernelPublishResultsRequest_CellResult[];
}

/**
 * See kernelshim.py for the differences between this and `ExecuteResult`.
 * https://jupyter-client.readthedocs.io/en/stable/messaging.html#execution-results
 */
export interface NotebookKernelPublishResultsRequest_ExecuteReply {
  status: string;
  executionCount: number;
  duration: number;
}

/** IOPub message or reply received from the kernel for a cell. */
export interface NotebookKernelPublishResultsRequest_CellResult {
  cellId: string;
  /** Persistent output that is saved in the notebook. */
  output?:
    | NotebookOutput
    | undefined;
  /** Clear all previous outputs of the cell. */
  clearOutput?:
    | boolean
    | undefined;
  /** Cell has finished executing, return the kernel's execute_reply. */
  executeReply?: NotebookKernelPublishResultsRequest_ExecuteReply | undefined;
}

/**
 * A single output from a notebook. When you execute a cell, it produces an
 * array of these outputs as the code runs.
 *
 * https://github.com/jupyter/nbformat/blob/v5.10.4/nbformat/v4/nbformat.v4.schema.json#L301-L309
 */
export interface NotebookOutput {
  executeResult?: NotebookOutput_ExecuteResult | undefined;
  displayData?: NotebookOutput_DisplayData | undefined;
  stream?: NotebookOutput_Stream | undefined;
  error?: NotebookOutput_Error | undefined;
}

/** Result of executing a code cell. */
export interface NotebookOutput_ExecuteResult {
  executionCount: number;
  /** mimebundle */
  data: { [key: string]: any } | undefined;
  metadata: { [key: string]: any } | undefined;
}

/** Data displayed as a result of code cell execution. */
export interface NotebookOutput_DisplayData {
  /** mimebundle */
  data: { [key: string]: any } | undefined;
  metadata:
    | { [key: string]: any }
    | undefined;
  /** This should not be included in saved notebook. */
  transientDisplayId?: string | undefined;
}

/** Stream output from a code cell (stdout / stderr). */
export interface NotebookOutput_Stream {
  /** stdout | stderr */
  name: string;
  /** multiline_string */
  text: string;
}

/** Output of an error that occurred during code cell execution. */
export interface NotebookOutput_Error {
  ename: string;
  evalue: string;
  traceback: string[];
}

export interface Object {
  objectId: string;
  functionHandleMetadata?: FunctionHandleMetadata | undefined;
  mountHandleMetadata?: MountHandleMetadata | undefined;
  classHandleMetadata?: ClassHandleMetadata | undefined;
  sandboxHandleMetadata?: SandboxHandleMetadata | undefined;
  volumeMetadata?: VolumeMetadata | undefined;
}

export interface ObjectDependency {
  objectId: string;
}

export interface PTYInfo {
  /** Soon deprecated */
  enabled: boolean;
  winszRows: number;
  winszCols: number;
  envTerm: string;
  envColorterm: string;
  envTermProgram: string;
  ptyType: PTYInfo_PTYType;
}

export enum PTYInfo_PTYType {
  /** PTY_TYPE_UNSPECIFIED - Nothing */
  PTY_TYPE_UNSPECIFIED = "PTY_TYPE_UNSPECIFIED",
  /** PTY_TYPE_FUNCTION - Run function in PTY */
  PTY_TYPE_FUNCTION = "PTY_TYPE_FUNCTION",
  /** PTY_TYPE_SHELL - Replace function with shell */
  PTY_TYPE_SHELL = "PTY_TYPE_SHELL",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface PortSpec {
  port: number;
  unencrypted: boolean;
  tunnelType?: TunnelType | undefined;
}

export interface PortSpecs {
  ports: PortSpec[];
}

export interface Proxy {
  name: string;
  createdAt: number;
  environmentName: string;
  proxyId: string;
  proxyIps: ProxyIp[];
}

export interface ProxyAddIpRequest {
  proxyId: string;
}

export interface ProxyAddIpResponse {
  proxyIp: ProxyIp | undefined;
}

export interface ProxyCreateRequest {
  name: string;
  environmentName: string;
}

export interface ProxyCreateResponse {
  proxy: Proxy | undefined;
}

export interface ProxyDeleteRequest {
  proxyId: string;
}

export interface ProxyGetOrCreateRequest {
  deploymentName: string;
  namespace: DeploymentNamespace;
  environmentName: string;
  /** must be UNSPECIFIED */
  objectCreationType: ObjectCreationType;
}

export interface ProxyGetOrCreateResponse {
  proxyId: string;
}

export interface ProxyGetRequest {
  name: string;
  environmentName: string;
}

export interface ProxyGetResponse {
  proxy: Proxy | undefined;
}

export interface ProxyInfo {
  elasticIp: string;
  proxyKey: string;
  remoteAddr: string;
  remotePort: number;
  proxyType: ProxyType;
}

export interface ProxyIp {
  proxyIp: string;
  status: ProxyIpStatus;
  createdAt: number;
  environmentName: string;
}

export interface ProxyListResponse {
  proxies: Proxy[];
}

export interface ProxyRemoveIpRequest {
  proxyIp: string;
}

export interface QueueClearRequest {
  queueId: string;
  partitionKey: Uint8Array;
  allPartitions: boolean;
}

export interface QueueDeleteRequest {
  queueId: string;
}

export interface QueueGetOrCreateRequest {
  deploymentName: string;
  namespace: DeploymentNamespace;
  environmentName: string;
  objectCreationType: ObjectCreationType;
}

export interface QueueGetOrCreateResponse {
  queueId: string;
}

export interface QueueGetRequest {
  queueId: string;
  timeout: number;
  nValues: number;
  partitionKey: Uint8Array;
}

export interface QueueGetResponse {
  values: Uint8Array[];
}

export interface QueueHeartbeatRequest {
  queueId: string;
}

export interface QueueItem {
  value: Uint8Array;
  entryId: string;
}

export interface QueueLenRequest {
  queueId: string;
  partitionKey: Uint8Array;
  total: boolean;
}

export interface QueueLenResponse {
  len: number;
}

export interface QueueListRequest {
  environmentName: string;
  /** Allow client to report a bounded total size to reduce the number of partitions that need to be checked */
  totalSizeLimit: number;
}

export interface QueueListResponse {
  queues: QueueListResponse_QueueInfo[];
}

export interface QueueListResponse_QueueInfo {
  name: string;
  createdAt: number;
  numPartitions: number;
  totalSize: number;
}

export interface QueueNextItemsRequest {
  queueId: string;
  partitionKey: Uint8Array;
  lastEntryId: string;
  /** seconds */
  itemPollTimeout: number;
}

export interface QueueNextItemsResponse {
  items: QueueItem[];
}

export interface QueuePutRequest {
  queueId: string;
  values: Uint8Array[];
  partitionKey: Uint8Array;
  partitionTtlSeconds: number;
}

export interface RateLimit {
  limit: number;
  interval: RateLimitInterval;
}

export interface Resources {
  /** MiB */
  memoryMb: number;
  /** milli CPU cores */
  milliCpu: number;
  gpuConfig:
    | GPUConfig
    | undefined;
  /** MiB */
  memoryMbMax: number;
  /** MiB */
  ephemeralDiskMb: number;
  /** milli CPU cores */
  milliCpuMax: number;
  /** Whether to use RDMA interfaces */
  rdma: boolean;
}

export interface RuntimeInputMessage {
  message: Uint8Array;
  messageIndex: string;
  eof: boolean;
}

export interface RuntimeOutputBatch {
  items: RuntimeOutputMessage[];
  batchIndex: string;
  /** if an exit code is given, this is the final message that will be sent. */
  exitCode?: number | undefined;
  stdout: RuntimeOutputMessage[];
  stderr: RuntimeOutputMessage[];
  info: RuntimeOutputMessage[];
}

/** Used for `modal container exec`, `modal shell`, and Sandboxes */
export interface RuntimeOutputMessage {
  /** only stdout / stderr is used */
  fileDescriptor: FileDescriptor;
  message: string;
  messageBytes: Uint8Array;
}

export interface S3Mount {
  bucketName: string;
  mountPath: string;
  credentialsSecretId: string;
  readOnly: boolean;
}

export interface Sandbox {
  entrypointArgs: string[];
  mountIds: string[];
  imageId: string;
  secretIds: string[];
  resources:
    | Resources
    | undefined;
  /** Deprecated at some point */
  cloudProvider: CloudProvider;
  timeoutSecs: number;
  workdir?: string | undefined;
  nfsMounts: SharedVolumeMount[];
  /** For internal debugging use only. */
  runtimeDebug: boolean;
  blockNetwork: boolean;
  s3Mounts: S3Mount[];
  cloudBucketMounts: CloudBucketMount[];
  volumeMounts: VolumeMount[];
  ptyInfo: PTYInfo | undefined;
  schedulerPlacement?:
    | SchedulerPlacement
    | undefined;
  /** for internal debugging use only */
  workerId: string;
  openPorts?: PortSpecs | undefined;
  i6pnEnabled: boolean;
  /** Network access configuration beyond simple allow/block. */
  networkAccess: NetworkAccess | undefined;
  proxyId?:
    | string
    | undefined;
  /**
   * Enable snapshotting the sandbox (both memory and filesystem).
   * This doesn't need to be enabled to save the filesystem as an image (i.e. a filesystem-only snapshot).
   */
  enableSnapshot: boolean;
  /**
   * Used to pin gVisor version for memory-snapshottable sandboxes.
   * This field is set by the server, not the client.
   */
  snapshotVersion?:
    | number
    | undefined;
  /** Supersedes cloud_provider */
  cloudProviderStr: string;
  /**
   * Specifies container runtime behavior for sandboxes which are restored from a snapshot.
   * Set by the backend at snapshot creation time.
   */
  runscRuntimeVersion?:
    | string
    | undefined;
  /** If set, overrides the runtime used by the function, either "runc" or "gvisor". */
  runtime?:
    | string
    | undefined;
  /** If set, the sandbox will be created with verbose logging enabled. */
  verbose: boolean;
}

export interface SandboxCreateRequest {
  appId: string;
  definition: Sandbox | undefined;
  environmentName: string;
}

export interface SandboxCreateResponse {
  sandboxId: string;
}

export interface SandboxGetLogsRequest {
  sandboxId: string;
  fileDescriptor: FileDescriptor;
  timeout: number;
  lastEntryId: string;
}

export interface SandboxGetResourceUsageRequest {
  sandboxId: string;
}

export interface SandboxGetResourceUsageResponse {
  cpuCoreNanosecs: string;
  memGibNanosecs: string;
  gpuNanosecs: string;
  gpuType?: string | undefined;
}

export interface SandboxGetTaskIdRequest {
  sandboxId: string;
  /** Legacy clients do not provide a timeout. New clients must always provide a timeout. */
  timeout?:
    | number
    | undefined;
  /** If true, waits until the container's postStart hook has been run before returning. Useful for detecting init failures. */
  waitUntilReady: boolean;
}

export interface SandboxGetTaskIdResponse {
  /** This is None if the sandbox was terminated before a task could be scheduled. */
  taskId?:
    | string
    | undefined;
  /** If the task has already exited, this is the result. */
  taskResult?: GenericResult | undefined;
}

export interface SandboxGetTunnelsRequest {
  sandboxId: string;
  timeout: number;
}

export interface SandboxGetTunnelsResponse {
  result: GenericResult | undefined;
  tunnels: TunnelData[];
}

export interface SandboxHandleMetadata {
  result: GenericResult | undefined;
}

export interface SandboxInfo {
  id: string;
  createdAt: number;
  taskInfo: TaskInfo | undefined;
  appId: string;
}

export interface SandboxListRequest {
  appId: string;
  beforeTimestamp: number;
  environmentName: string;
  includeFinished: boolean;
  tags: SandboxTag[];
}

export interface SandboxListResponse {
  sandboxes: SandboxInfo[];
}

export interface SandboxRestoreRequest {
  snapshotId: string;
}

export interface SandboxRestoreResponse {
  sandboxId: string;
}

export interface SandboxSnapshotFsRequest {
  sandboxId: string;
  timeout: number;
}

export interface SandboxSnapshotFsResponse {
  imageId: string;
  result:
    | GenericResult
    | undefined;
  /** Metadata may be empty since we may skip it for performance reasons. */
  imageMetadata: ImageMetadata | undefined;
}

export interface SandboxSnapshotGetRequest {
  snapshotId: string;
}

export interface SandboxSnapshotGetResponse {
  snapshotId: string;
}

export interface SandboxSnapshotRequest {
  sandboxId: string;
}

export interface SandboxSnapshotResponse {
  snapshotId: string;
}

export interface SandboxSnapshotWaitRequest {
  snapshotId: string;
  timeout: number;
}

export interface SandboxSnapshotWaitResponse {
  result: GenericResult | undefined;
}

export interface SandboxStdinWriteRequest {
  sandboxId: string;
  input: Uint8Array;
  index: number;
  eof: boolean;
}

export interface SandboxStdinWriteResponse {
}

export interface SandboxTag {
  tagName: string;
  tagValue: string;
}

export interface SandboxTagsSetRequest {
  environmentName: string;
  sandboxId: string;
  tags: SandboxTag[];
}

export interface SandboxTerminateRequest {
  sandboxId: string;
}

export interface SandboxTerminateResponse {
  existingResult: GenericResult | undefined;
}

export interface SandboxWaitRequest {
  sandboxId: string;
  timeout: number;
}

export interface SandboxWaitResponse {
  result: GenericResult | undefined;
}

export interface Schedule {
  cron?: Schedule_Cron | undefined;
  period?: Schedule_Period | undefined;
}

export interface Schedule_Cron {
  cronString: string;
  timezone: string;
}

export interface Schedule_Period {
  years: number;
  months: number;
  weeks: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

/**
 * TODO(irfansharif):
 * - Fold in cloud, resource needs here too.
 * - Allow specifying list of zones, cloud, fallback and alternative
 *   GPU types.
 */
export interface SchedulerPlacement {
  regions: string[];
  /** TODO(irfansharif): Make these two repeated. */
  Zone?:
    | string
    | undefined;
  /** admin-only, "on-demand" or "spot", else ignored */
  Lifecycle?:
    | string
    | undefined;
  /** admin-only */
  InstanceTypes: string[];
}

/** Not used by client anymore */
export interface SecretCreateRequest {
  envDict: { [key: string]: string };
  appId: string;
  /** todo: not used? */
  templateType: string;
  existingSecretId: string;
}

export interface SecretCreateRequest_EnvDictEntry {
  key: string;
  value: string;
}

/** Not used by client anymore */
export interface SecretCreateResponse {
  secretId: string;
}

export interface SecretDeleteRequest {
  secretId: string;
}

export interface SecretGetOrCreateRequest {
  deploymentName: string;
  namespace: DeploymentNamespace;
  environmentName: string;
  /** Not used atm */
  objectCreationType: ObjectCreationType;
  envDict: { [key: string]: string };
  /** only used with OBJECT_CREATION_TYPE_ANONYMOUS_OWNED_BY_APP */
  appId: string;
  requiredKeys: string[];
}

export interface SecretGetOrCreateRequest_EnvDictEntry {
  key: string;
  value: string;
}

export interface SecretGetOrCreateResponse {
  secretId: string;
}

export interface SecretListItem {
  label: string;
  createdAt: number;
  lastUsedAt: number;
  environmentName: string;
  secretId: string;
}

export interface SecretListRequest {
  /** leaving empty will assume a singular environment */
  environmentName: string;
}

export interface SecretListResponse {
  items: SecretListItem[];
  /** the environment that was listed (useful when relying on "default" logic) */
  environmentName: string;
}

export interface SharedVolumeDeleteRequest {
  sharedVolumeId: string;
}

export interface SharedVolumeGetFileRequest {
  sharedVolumeId: string;
  path: string;
}

export interface SharedVolumeGetFileResponse {
  data?: Uint8Array | undefined;
  dataBlobId?: string | undefined;
}

export interface SharedVolumeGetOrCreateRequest {
  deploymentName: string;
  namespace: DeploymentNamespace;
  environmentName: string;
  objectCreationType: ObjectCreationType;
  /** only used with OBJECT_CREATION_TYPE_ANONYMOUS_OWNED_BY_APP */
  appId: string;
}

export interface SharedVolumeGetOrCreateResponse {
  sharedVolumeId: string;
}

export interface SharedVolumeHeartbeatRequest {
  sharedVolumeId: string;
}

export interface SharedVolumeListFilesRequest {
  sharedVolumeId: string;
  path: string;
}

export interface SharedVolumeListFilesResponse {
  entries: FileEntry[];
}

export interface SharedVolumeListItem {
  /** app name of object entity app */
  label: string;
  sharedVolumeId: string;
  createdAt: number;
  cloudProvider: CloudProvider;
}

export interface SharedVolumeListRequest {
  environmentName: string;
}

export interface SharedVolumeListResponse {
  items: SharedVolumeListItem[];
  environmentName: string;
}

export interface SharedVolumeMount {
  mountPath: string;
  sharedVolumeId: string;
  cloudProvider: CloudProvider;
  allowCrossRegion: boolean;
}

export interface SharedVolumePutFileRequest {
  sharedVolumeId: string;
  path: string;
  sha256Hex: string;
  data?: Uint8Array | undefined;
  dataBlobId?:
    | string
    | undefined;
  /** remove when required client version >= 47 */
  resumable: boolean;
}

export interface SharedVolumePutFileResponse {
  exists: boolean;
}

export interface SharedVolumeRemoveFileRequest {
  sharedVolumeId: string;
  path: string;
  recursive: boolean;
}

export interface SystemErrorMessage {
  errorCode: SystemErrorCode;
  errorMessage: string;
}

export interface TaskClusterHelloRequest {
  taskId: string;
  containerIp: string;
}

export interface TaskClusterHelloResponse {
  clusterId: string;
  clusterRank: number;
  /** All IP addresses in cluster, ordered by cluster rank */
  containerIps: string[];
}

export interface TaskCurrentInputsResponse {
  inputIds: string[];
}

export interface TaskInfo {
  id: string;
  startedAt: number;
  finishedAt: number;
  result: GenericResult | undefined;
  enqueuedAt: number;
  gpuType: string;
  sandboxId: string;
}

export interface TaskListRequest {
  environmentName: string;
}

export interface TaskListResponse {
  tasks: TaskStats[];
}

export interface TaskLogs {
  data: string;
  taskState: TaskState;
  timestamp: number;
  fileDescriptor: FileDescriptor;
  taskProgress: TaskProgress | undefined;
  functionCallId: string;
  inputId: string;
  timestampNs: string;
}

export interface TaskLogsBatch {
  taskId: string;
  items: TaskLogs[];
  entryId: string;
  appDone: boolean;
  functionId: string;
  inputId: string;
  /** Used for image logs */
  imageId: string;
  eof: boolean;
  /** Used for interactive functions */
  ptyExecId: string;
  rootFunctionId: string;
}

export interface TaskProgress {
  len: string;
  pos: string;
  progressType: ProgressType;
  description: string;
}

export interface TaskResultRequest {
  result: GenericResult | undefined;
}

export interface TaskStats {
  taskId: string;
  appId: string;
  appDescription: string;
  startedAt: number;
}

export interface TaskTemplate {
  rank: number;
  resources: Resources | undefined;
  targetConcurrentInputs: number;
  maxConcurrentInputs: number;
  /**
   * TODO(irfansharif): Just move this into a column in the task table instead?
   * Deprecate all above fields and get rid of this message altogether
   */
  index: number;
}

export interface TokenFlowCreateRequest {
  utmSource: string;
  localhostPort: number;
  nextUrl: string;
}

export interface TokenFlowCreateResponse {
  tokenFlowId: string;
  webUrl: string;
  code: string;
  waitSecret: string;
}

export interface TokenFlowWaitRequest {
  timeout: number;
  tokenFlowId: string;
  waitSecret: string;
}

export interface TokenFlowWaitResponse {
  tokenId: string;
  tokenSecret: string;
  timeout: boolean;
  workspaceUsername: string;
}

export interface TunnelData {
  host: string;
  port: number;
  unencryptedHost?: string | undefined;
  unencryptedPort?: number | undefined;
  containerPort: number;
}

export interface TunnelStartRequest {
  port: number;
  unencrypted: boolean;
  tunnelType?: TunnelType | undefined;
}

export interface TunnelStartResponse {
  host: string;
  port: number;
  unencryptedHost?: string | undefined;
  unencryptedPort?: number | undefined;
}

export interface TunnelStopRequest {
  port: number;
}

export interface TunnelStopResponse {
  exists: boolean;
}

export interface VolumeCommitRequest {
  /**
   * NOTE(staffan): Mounting a volume in multiple locations is not supported, so volume_id alone uniquely identifies
   * a volume mount.
   */
  volumeId: string;
}

export interface VolumeCommitResponse {
  skipReload: boolean;
}

export interface VolumeCopyFiles2Request {
  volumeId: string;
  srcPaths: string[];
  dstPath: string;
  recursive: boolean;
}

export interface VolumeCopyFilesRequest {
  volumeId: string;
  srcPaths: string[];
  dstPath: string;
  recursive: boolean;
}

export interface VolumeDeleteRequest {
  volumeId: string;
  /** @deprecated */
  environmentName: string;
}

export interface VolumeGetFile2Request {
  volumeId: string;
  path: string;
  start: string;
  /** 0 is interpreted as 'read to end' */
  len: string;
}

export interface VolumeGetFile2Response {
  getUrls: string[];
  /** total file size */
  size: string;
  /** file position of first byte returned */
  start: string;
  /** number of bytes returned */
  len: string;
}

export interface VolumeGetFileRequest {
  volumeId: string;
  path: string;
  start: string;
  /** 0 is interpreted as 'read to end' */
  len: string;
}

export interface VolumeGetFileResponse {
  data?: Uint8Array | undefined;
  dataBlobId?:
    | string
    | undefined;
  /** total file size */
  size: string;
  /** file position of first byte returned */
  start: string;
  /** number of bytes returned */
  len: string;
}

export interface VolumeGetOrCreateRequest {
  deploymentName: string;
  namespace: DeploymentNamespace;
  environmentName: string;
  objectCreationType: ObjectCreationType;
  /** only used with OBJECT_CREATION_TYPE_ANONYMOUS_OWNED_BY_APP */
  appId: string;
  version: VolumeFsVersion;
}

export interface VolumeGetOrCreateResponse {
  volumeId: string;
  version: VolumeFsVersion;
  metadata: VolumeMetadata | undefined;
}

export interface VolumeHeartbeatRequest {
  volumeId: string;
}

export interface VolumeListFiles2Request {
  volumeId: string;
  path: string;
  recursive: boolean;
  maxEntries?: number | undefined;
}

export interface VolumeListFiles2Response {
  entries: FileEntry[];
}

export interface VolumeListFilesRequest {
  volumeId: string;
  path: string;
  recursive: boolean;
  maxEntries?: number | undefined;
}

export interface VolumeListFilesResponse {
  entries: FileEntry[];
}

export interface VolumeListItem {
  /** app name of object entity app */
  label: string;
  volumeId: string;
  createdAt: number;
}

export interface VolumeListRequest {
  environmentName: string;
}

export interface VolumeListResponse {
  items: VolumeListItem[];
  environmentName: string;
}

export interface VolumeMetadata {
  version: VolumeFsVersion;
}

export interface VolumeMount {
  volumeId: string;
  mountPath: string;
  allowBackgroundCommits: boolean;
  readOnly: boolean;
}

export interface VolumePutFiles2Request {
  /** The ID of the volume to put/upload files into. */
  volumeId: string;
  /** List of files to put/upload. */
  files: VolumePutFiles2Request_File[];
  /**
   * If set to true, prevent overwriting existing files. (Note that we don't
   * allow overwriting existing directories with uploaded files regardless.)
   */
  disallowOverwriteExistingFiles: boolean;
}

export interface VolumePutFiles2Request_File {
  /**
   * Destination path of the file to be uploaded, including any parent dirs
   * etc.; for example "foo/bar/baz.txt"
   */
  path: string;
  /** The total size of the file, in bytes. */
  size: string;
  /** The blocks, in units of 8MiB, that this file consists of. */
  blocks: VolumePutFiles2Request_Block[];
  /** Unix file permission bits `st_mode`. */
  mode?: number | undefined;
}

export interface VolumePutFiles2Request_Block {
  /**
   * The SHA256 digest of the contents of this block, in raw (ie. 32 bytes)
   * form for compactness.
   */
  contentsSha256: Uint8Array;
  /**
   * From a previous call to `VolumePutFiles2`, we might have gotten a
   * response indicating that this block was missing.
   *
   * For such a block, this field contains the raw bytes of the body that
   * was returned from the HTTP PUT request when the client made a request
   * for the `put_url` returned in the previous `VolumePutFiles2Response`.
   */
  putResponse?: Uint8Array | undefined;
}

export interface VolumePutFiles2Response {
  /**
   * Blocks that are currently missing in the volume, because the file did not
   * exist, or because the block checksum from `blocks_sha256` in the request
   * did not match the current contents of the file.
   *
   * Values will be returned sorted by `(file_index, block_index)`.
   *
   * If this field is empty, it means that the files were uploaded successfully
   * and/or that the request was an idempotent no-op.
   */
  missingBlocks: VolumePutFiles2Response_MissingBlock[];
}

export interface VolumePutFiles2Response_MissingBlock {
  /** Index of the file in the original `files` field of the request. */
  fileIndex: string;
  /**
   * The index of the block in the original `files[file_index].blocks` of the
   * request.
   */
  blockIndex: string;
  /**
   * Make a HTTP PUT request to this endpoint with the blocks' contents as
   * the body.
   */
  putUrl: string;
}

export interface VolumePutFilesRequest {
  volumeId: string;
  /** TODO(staffan): This is obviously unfortunately named, but provides what we need - consider renaming. */
  files: MountFile[];
  /**
   * If set to true, prevent overwriting existing files. (Note that we don't allow overwriting
   * existing directories with uploaded files regardless.)
   */
  disallowOverwriteExistingFiles: boolean;
}

export interface VolumeReloadRequest {
  /**
   * NOTE(staffan): Mounting a volume in multiple locations is not supported, so volume_id alone uniquely identifies
   * a volume mount.
   */
  volumeId: string;
}

export interface VolumeRemoveFile2Request {
  volumeId: string;
  path: string;
  recursive: boolean;
}

export interface VolumeRemoveFileRequest {
  volumeId: string;
  path: string;
  recursive: boolean;
}

export interface VolumeRenameRequest {
  volumeId: string;
  name: string;
}

export interface Warning {
  type: Warning_WarningType;
  message: string;
}

export enum Warning_WarningType {
  WARNING_TYPE_UNSPECIFIED = "WARNING_TYPE_UNSPECIFIED",
  WARNING_TYPE_CLIENT_DEPRECATION = "WARNING_TYPE_CLIENT_DEPRECATION",
  WARNING_TYPE_RESOURCE_LIMIT = "WARNING_TYPE_RESOURCE_LIMIT",
  WARNING_TYPE_FUNCTION_CONFIGURATION = "WARNING_TYPE_FUNCTION_CONFIGURATION",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface WebUrlInfo {
  truncated: boolean;
  /** @deprecated */
  hasUniqueHash: boolean;
  labelStolen: boolean;
}

export interface WebhookConfig {
  type: WebhookType;
  method: string;
  requestedSuffix: string;
  asyncMode: WebhookAsyncMode;
  customDomains: CustomDomainConfig[];
  webServerPort: number;
  webServerStartupTimeout: number;
  webEndpointDocs: boolean;
  requiresProxyAuth: boolean;
}

export interface WorkspaceNameLookupResponse {
  /** @deprecated */
  workspaceName: string;
  username: string;
}
